import { Card, Stack } from "@mui/material";
import FieldsArrayList from "components/form/FieldsArrayList";
import TextFieldControl from "components/form/TextFieldControl";
import GenerationField from "../GenerationField";

interface ContentCriteriaProps {
  isEditing: boolean;
  skillId: string | undefined;
}

const ContentCriteria = ({ isEditing, skillId }: ContentCriteriaProps) => {
  const fieldName = "criterion";

  return (
    <Card>
      <Stack spacing={2}>
        <FieldsArrayList
          disabled={!isEditing}
          fieldName={fieldName}
          label='Критерии оценки ответа'
          totalCountLabel='Количество критериев'
          addButtonText='критерий оценки'
          renderFieldControlsComponent={(index) => (
            <TextFieldControl
              multiline
              maxRows={4}
              name={`${fieldName}.${index}.value`}
              rules={{ required: true }}
              disabled={!isEditing}
              stackSx={{ width: "100%" }}
              placeholder='Текст критерия оценки'
            />
          )}
        />
        <GenerationField
          name='criteriaComment'
          label='Комментарий к критериям'
          successText='Критерии сгенерированы'
          generationType='criteria'
          skillId={skillId}
          isEditing={isEditing}
        />
      </Stack>
    </Card>
  );
};

export default ContentCriteria;
